import React, {useState} from 'react';

import './Text.css';

const TextEditor = (props) => {

    const [isShown, setIsShown] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [name, setName] = useState(props.name);

    if(props.disabled) {
        return (
            <div className="TextEditor">
                <div className="box-title"> 
                    <span>{props.name}</span>
                </div>
            </div>
            
        )
    }

    return (
        <div className="TextEditor">
            {isEdit ? (
                <div className="form-group">
                    <div className="input-group input-group-sm">
                        <input type="text" className="form-control" value={name} onChange={(e) => {
                            setName(e.target.value)
                        }}/>
                        <span className="input-group-btn">
                            <button type="button" className="btn btn-info btn-flat" onClick={() => {
                                setIsEdit(false)
                                props.save(name)
                            }}>Confirm!</button>
                        </span>
                    </div>
                </div>
            ) : (
                <div className="box-title"
                    onMouseEnter={() => setIsShown(true)}
                    onMouseLeave={() => setIsShown(false)}
                > 
                    <i className="fa fa-arrows Dragable" style={{cursor: "pointer"}}></i>
                    &nbsp;
                    <span>{props.name}</span>
                    &nbsp;&nbsp;{isShown && !isEdit && (
                        <React.Fragment>
                            <a onClick={() => setIsEdit(!isEdit)}><i className="fa fa-pencil"></i></a>
                            &nbsp;&nbsp;
                            <a onClick={() => props.remove()} className="text-red"><i className="fa fa-trash"></i></a>
                        </React.Fragment>
                    )}
                </div>
            )}
        </div>
    )
};

export default React.memo(TextEditor);